import { Breadcrumb, BreadcrumbProps } from "antd"

export const BreadcrumbWrap: React.FC<BreadcrumbProps> = ({
  className,
  ...props
}) => {
  return <Breadcrumb className={className} {...props} />
}
